const definitions = [
  {
    name: "Gem Grove", category: "Puzzle", price: 899, family: "match", shortDescription: "Swap bright garden gems and build explosive three-in-a-row chains.",
    config: { target: 180, fullTarget: 520 }, session: "3–8 minutes", tags: ["Puzzle", "Match 3", "Turn-based"],
    controls: ["Click or tap one gem, then an adjacent gem", "Only swaps that create a match are kept"],
    instructions: ["Choose neighbouring gems", "Create lines of three or more", "Reach the score target before moves run out"],
    limit: "The demo is a 12-move score challenge with a 180-point target.",
    difference: "The full edition unlocks a 24-move board and a 520-point chain target.",
    unlocks: ["24-move grove board", "520-point chain target", "Local full-edition access"], featured: true,
  },
  {
    name: "Canopy Sprint", category: "Arcade", price: 899, family: "runner", shortDescription: "Dash through a painted forest and leap over roots and thorn bushes.",
    config: { distance: 260, fullDistance: 780, speed: 4.2 }, session: "2–6 minutes", tags: ["Arcade", "Runner", "Real-time"],
    controls: ["Space, Arrow Up or tap Jump", "P or the HUD button pauses the run"],
    instructions: ["Start the forest sprint", "Time jumps over every obstacle", "Reach the finish distance"],
    limit: "The demo finishes at 260 metres.", difference: "The full edition unlocks the complete 780-metre forest course.",
    unlocks: ["780-metre forest course", "Extended obstacle sequence", "Local full-edition access"], featured: true,
  },
  {
    name: "Cavewing Course", category: "Arcade", price: 799, family: "flyer", shortDescription: "Keep a tiny glider aloft and thread a tightening chain of cave gaps.",
    config: { speed: 3.15 }, session: "1–5 minutes", tags: ["Arcade", "One tap", "Real-time"],
    controls: ["Tap, click, Space or Arrow Up to flap", "P or the HUD button pauses flight"],
    instructions: ["Tap to gain height", "Release to fall with gravity", "Fly cleanly through every gap"],
    limit: "The demo asks you to clear six cave gates.", difference: "The full edition unlocks a sixteen-gate endurance flight.",
    unlocks: ["Sixteen-gate cave course", "Long-form score chase", "Local full-edition access"], featured: true,
  },
  {
    name: "Iron Orchard", category: "Strategy", price: 1099, family: "tower", shortDescription: "Place compact turrets around the road and stop a marching iron convoy.",
    config: { waves: 3, fullWaves: 7, gold: 5 }, session: "4–10 minutes", tags: ["Strategy", "Tower defense", "Turn-based"],
    controls: ["Click open grass pads to build turrets", "Advance moves the convoy and resolves turret fire"],
    instructions: ["Read the convoy lane", "Place turrets within firing range", "Stop every wave before the gate"],
    limit: "The demo contains three convoy waves and five starting energy.", difference: "The full edition unlocks seven waves and an expanded build budget.",
    unlocks: ["Seven convoy waves", "Expanded turret budget", "Local full-edition access"], featured: true,
  },
  {
    name: "Skybound Sling", category: "Arcade", price: 999, family: "slingshot", shortDescription: "Pull back a winged hero and sling from one floating island to the next.",
    config: {}, session: "2–7 minutes", tags: ["Arcade", "Slingshot", "Physics"],
    controls: ["Drag down from the hero and release to launch", "P or the HUD button pauses physics"],
    instructions: ["Pull opposite the intended flight", "Release to arc toward an island", "Land progressively higher"],
    limit: "The demo tower ends after four successful island landings.", difference: "The full edition unlocks an eight-landing sky tower.",
    unlocks: ["Eight-landing tower", "Extended physics climb", "Local full-edition access"], featured: true,
  },
  {
    name: "Berry Blade", category: "Arcade", price: 799, family: "slice", shortDescription: "Swipe through flying fruit, build a clean harvest and leave bombs untouched.",
    config: {}, session: "2–6 minutes", tags: ["Arcade", "Action", "Pointer"],
    controls: ["Hold and drag across fruit with mouse or touch", "P or the HUD button pauses the tosses"],
    instructions: ["Follow each fruit arc", "Slice fruit with a quick drag", "Avoid every dark bomb"],
    limit: "The demo ends after twelve clean fruit slices or three bomb hits.", difference: "The full edition unlocks a thirty-fruit combo run.",
    unlocks: ["Thirty-fruit challenge", "Longer combo run", "Local full-edition access"], featured: true,
  },
  {
    name: "Merge Manor", category: "Puzzle", price: 699, family: "merge", shortDescription: "Slide numbered rooms together and forge increasingly valuable tiles.",
    config: { target: 64, fullTarget: 512 }, session: "3–12 minutes", tags: ["Puzzle", "Merge", "Turn-based"],
    controls: ["Arrow keys, direction buttons or swipe", "R restarts the current board"],
    instructions: ["Slide every tile at once", "Merge equal neighbours", "Build the target tile before the board locks"],
    limit: "The demo ends when you create a 64 tile.", difference: "The full edition extends the board goal to the 512 tile.",
    unlocks: ["512-tile challenge", "Extended score chase", "Local full-edition access"], featured: true,
  },
  {
    name: "Word Foundry", category: "Puzzle", price: 599, family: "word", shortDescription: "Forge the hidden five-letter word from exact, present and absent clues.",
    config: { word: "BLOOM" }, session: "2–8 minutes", tags: ["Puzzle", "Word", "Keyboard"],
    controls: ["Type a five-letter word and press Forge", "Green is exact; gold belongs elsewhere"],
    instructions: ["Enter a valid five-letter guess", "Read the coloured letter clues", "Find the word before guesses expire"],
    limit: "The demo provides six guesses for one handcrafted word.", difference: "The full edition unlocks two extra guesses and the extended word session.",
    unlocks: ["Eight-guess word session", "Extended clue allowance", "Local full-edition access"], featured: true,
  },
  {
    name: "Block Bloom", category: "Puzzle", price: 899, family: "blocks", shortDescription: "Fit offered shapes on an 8×8 garden board and clear full rows or columns.",
    config: {}, session: "4–12 minutes", tags: ["Puzzle", "Block placement", "Turn-based"],
    controls: ["Choose one of the available shapes", "Tap an empty cell to place its top-left corner"],
    instructions: ["Select a shape from the rack", "Fit it without overlapping blocks", "Fill complete lines to clear and score"],
    limit: "The demo target is 180 points on the 8×8 board.", difference: "The full edition unlocks the 450-point endurance target.",
    unlocks: ["450-point board target", "Extended piece sequence", "Local full-edition access"], featured: false,
  },
  {
    name: "Nine Grid", category: "Puzzle", price: 699, family: "sudoku", shortDescription: "Complete a clean 9×9 number grid with logic and a three-mistake limit.",
    config: {}, session: "5–18 minutes", tags: ["Puzzle", "Sudoku", "Logic"],
    controls: ["Select an empty cell, then choose 1–9", "Clue cells cannot be edited"],
    instructions: ["Inspect each row and column", "Choose a blank cell", "Place the only valid number"],
    limit: "The demo presents a guided grid with twenty missing cells.", difference: "The full edition unlocks a harder grid with thirty-eight missing cells.",
    unlocks: ["Thirty-eight-blank sudoku", "Harder deduction layout", "Local full-edition access"], featured: false,
  },
  {
    name: "Three Marks", category: "Strategy", price: 499, family: "tictactoe", shortDescription: "Play X against a defensive AI and protect a growing win streak.",
    config: {}, session: "2–8 minutes", tags: ["Strategy", "Classic", "AI opponent"],
    controls: ["Click or tap an empty square to place X", "The AI immediately answers with O"],
    instructions: ["Create a line of three X marks", "Block the AI's immediate threats", "Win consecutive rounds"],
    limit: "The demo gauntlet requires two consecutive wins.", difference: "The full edition unlocks a four-win AI gauntlet.",
    unlocks: ["Four-win gauntlet", "Extended AI challenge", "Local full-edition access"], featured: false,
  },
  {
    name: "Secret Sets", category: "Puzzle", price: 599, family: "grouping", shortDescription: "Sort sixteen words into hidden groups linked by one precise idea.",
    config: {}, session: "3–10 minutes", tags: ["Puzzle", "Words", "Grouping"],
    controls: ["Select exactly four word tiles", "Check Group tests the shared connection"],
    instructions: ["Read all sixteen words", "Select four with one connection", "Solve groups before four mistakes"],
    limit: "The demo ends after finding two groups.", difference: "The full edition unlocks the complete four-group board.",
    unlocks: ["All four hidden groups", "Complete sixteen-word board", "Local full-edition access"], featured: false,
  },
  {
    name: "Night Swarm", category: "Action", price: 1099, family: "shooter", shortDescription: "Move through a top-down night arena while auto-fire tracks the nearest creature.",
    config: {}, session: "2–8 minutes", tags: ["Action", "Survival", "Auto-fire"],
    controls: ["Move with WASD, arrows or pointer drag", "P or the HUD button pauses the wave"],
    instructions: ["Stay mobile inside the arena", "Let auto-fire track the nearest target", "Survive the required number of kills"],
    limit: "The demo wave ends after ten defeated creatures.", difference: "The full edition unlocks a twenty-eight-creature survival wave.",
    unlocks: ["Twenty-eight-creature wave", "Long-form survival arena", "Local full-edition access"], featured: false,
  },
  {
    name: "Nebula Drift", category: "Arcade", price: 899, family: "space", shortDescription: "Shift a small ship through falling debris and collect luminous star cores.",
    config: {}, session: "2–7 minutes", tags: ["Arcade", "Space", "Dodge"],
    controls: ["Use A / D, arrow keys or drag horizontally", "P or the HUD button pauses the field"],
    instructions: ["Steer beneath incoming objects", "Collect gold star cores", "Avoid grey debris and protect the hull"],
    limit: "The demo route requires seven star cores.", difference: "The full edition unlocks an eighteen-core nebula crossing.",
    unlocks: ["Eighteen-core crossing", "Extended debris field", "Local full-edition access"], featured: false,
  },
];

const productData = definitions.map((definition, index) => {
  const id = index + 1;
  const slug = definition.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  const screenshots = [1, 2, 3].map((scene) => `/img/games/${slug}-${scene}.png`);
  return {
    id,
    slug,
    name: definition.name,
    category: definition.category,
    price: definition.price,
    currency: "USD",
    coverImage: screenshots[0],
    image: screenshots[0],
    images: screenshots,
    screenshots,
    shortDescription: definition.shortDescription,
    description: `${definition.shortDescription} This is an original, locally implemented browser game with progress stored only on this device.`,
    attributes: { session: definition.session, save: "This browser only", age: "Everyone" },
    tags: definition.tags,
    platform: "Modern desktop and mobile browsers",
    languages: ["English"],
    controls: definition.controls,
    instructions: definition.instructions,
    demo: {
      gameKey: `${definition.family}/${slug}`,
      controls: definition.controls.join(" · "),
      config: definition.config,
      limit: definition.limit,
      difference: definition.difference,
    },
    versions: [{ id: "full", name: "Full Browser Edition", price: definition.price, unlocks: definition.unlocks }],
    unlocks: definition.difference,
    featured: definition.featured,
  };
});

export default productData;
